// This function removes the white spaces from the template name and adds - in between if there isn't any, so it has a nice look in the url.

function removeSpacesFromUrl(templateName) {
  const splitTemplateName = templateName.split(" ");
  const newTemplateName = [splitTemplateName[0]];

  for (let i = 1; i < splitTemplateName.length; i++) {
    if (splitTemplateName[i - 1] !== "-" && splitTemplateName[i] !== "-") {
      newTemplateName.push("-");
    }
    newTemplateName.push(splitTemplateName[i]);
  }
  return newTemplateName.join("").toLowerCase();
}

export default removeSpacesFromUrl;
